import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { SettingsPage } from '@/features/settings/components';
import type { SettingsSectionId } from '@/features/settings/components';

function SettingsRoute(): ReactNode {
  const search = Route.useSearch();
  return (
    <AuthGuard>
      <SettingsPage {...(search.section !== undefined ? { initialSection: search.section } : {})} />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/settings')({
  validateSearch,
  component: SettingsRoute,
});

function validateSearch(raw: Record<string, unknown>): { section?: SettingsSectionId } {
  return raw.section === 'appearance'
    || raw.section === 'language'
    || raw.section === 'notifications'
    || raw.section === 'account'
    || raw.section === 'security'
    ? { section: raw.section }
    : {};
}
